import classNames from 'classnames';
import React from 'react';
import { useI18n } from '@udemy/i18n';
import { Icon } from '@udemy/icons';
import { Loader } from '@udemy/react-reveal-components';
import styles from "./error-component.module.css";
import { withCoursePriceStoreBase } from './with-course-price-store-base';
export const ErrorComponent = ({
  className
}) => {
  const {
    gettext
  } = useI18n();
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles['error-container'], className])
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "error",
    label: false,
    color: "negative"
  }), /*#__PURE__*/React.createElement("span", {
    className: classNames([styles['error-text'], 'ud-heading-xs'])
  }, gettext('Error loading price')));
};
export const LoaderComponent = ({
  className
}) => /*#__PURE__*/React.createElement("div", {
  className: classNames([className])
}, /*#__PURE__*/React.createElement(Loader, null));
export const withCoursePriceStore = withCoursePriceStoreBase(LoaderComponent, ErrorComponent);
//# sourceMappingURL=with-course-price-store.js.map